import { APP_ENVIRONMENTS, DEPLOYMENT_MODES } from '@aibi/shared';
import { z } from 'zod';
import { IsoDateTimeSchema } from './common.js';

/** Respuesta de `GET /api/health`. Contrato compartido entre servidor y clientes. */
export const HealthResponseSchema = z.object({
  status: z.literal('ok'),
  service: z.literal('aibi-server'),
  version: z.string().min(1),
  appEnv: z.enum(APP_ENVIRONMENTS),
  deploymentMode: z.enum(DEPLOYMENT_MODES),
  uptimeSeconds: z.number().nonnegative(),
  timestamp: IsoDateTimeSchema,
});
export type HealthResponse = z.infer<typeof HealthResponseSchema>;

/** Cuerpo estandar de error devuelto por la API. */
export const ApiErrorSchema = z.object({
  code: z.string().min(1),
  message: z.string(),
  details: z.array(z.object({ path: z.string(), message: z.string() })).default([]),
});
export type ApiError = z.infer<typeof ApiErrorSchema>;

export const API_ROUTES = {
  health: '/api/health',
} as const;
